import React, { useEffect } from "react";
import styled from "styled-components";

import Gettext from "./common/Gettext";

const StyledBadge = styled.div`
  position: absolute;
  top: 5px;
  right: 10px;
  background: rgb(189, 59, 59);
  color: white;
  font-size: 9px;
  font-weight: 700;
  padding: 5px;
  border-radius: 5px;
  z-index: 9999;

  @media (min-width: 960px) {
    font-size: 12px;
    padding: 5px 10px;
  }
`;

export const OfflineBadge = () => (
  <StyledBadge>
    <Gettext>You are currently offline</Gettext>
  </StyledBadge>
);

const OnLine = (props) => {
  const onStatusChange = () => {
    if (typeof props.onChange === "function") {
      props.onChange(window.navigator.onLine);
    }
  };

  useEffect(() => {
    window.addEventListener("online", onStatusChange);
    return () => window.removeEventListener("online", onStatusChange);
  });

  useEffect(() => {
    window.addEventListener("offline", onStatusChange);
    return () => window.removeEventListener("offline", onStatusChange);
  });

  if (window.navigator.onLine === undefined) return null;

  return typeof props.children === "function" ? props.children(window.navigator.onLine) : null;
};

export default OnLine;



// WEBPACK FOOTER //
// ./src/components/OnLine.js